/*********************************************************************************
 1. Dependencies
 *********************************************************************************/

import styled from 'styled-components';
import { Colours } from '../../../styles/variables';
import { Media } from '../../../styles/utilities';


/*********************************************************************************
 2. Component
 *********************************************************************************/

export const StyledIconLink = styled.a`
  color: ${props => props.textColour || Colours.White};
  text-decoration: none;
  outline: 0;
  margin: ${props => props.margin || '20px'};
  display: inline-block;
  ${Media.Tablet`
    margin: ${props => props.margin || '30px'};
  `}
`;



// WEBPACK FOOTER //
// ./src/components/atoms/StyledIconLink/index.js